import { Box } from "@chakra-ui/react"
import { ReactNode } from "react"

type AtmosphericBackgroundProps = {
  image?: string
  children?: ReactNode | ReactNode[]
}

function AtmosphericBackground({
  image,
  children
}: AtmosphericBackgroundProps) {
  return (
    <Box height="100%" bg="gray.50" borderRadius="inhert" overflow="hidden">
      <Box
        filter="auto"
        blur="15px"
        position="absolute"
        top={0}
        left={0}
        right={0}
        width="100%"
        height="100%"
        overflow="hidden"
      >
        {!!image && (
          <Box
            bgImage={`url(${image})`}
            bgSize="cover"
            bgPosition="center bottom"
            bgRepeat="no-repeat"
            width="100%"
            height="100%"
          />
        )}
        <Box
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          bg="white"
          opacity="0.8"
        />
      </Box>
      {!!children && (
        <Box position="relative" h="100%" w="100%">
          {children}
        </Box>
      )}
    </Box>
  )
}

export default AtmosphericBackground
